/**
 * @flow
 */

/* eslint-disable */

'use strict';

/*::
import type { ConcreteRequest } from 'relay-runtime';
export type IngredientRecipeDeleteModalMutationVariables = {|
  id: string
|};
export type IngredientRecipeDeleteModalMutationResponse = {|
  +recipeIngredientDelete: ?{|
    +deleted: ?boolean
  |}
|};
export type IngredientRecipeDeleteModalMutation = {|
  variables: IngredientRecipeDeleteModalMutationVariables,
  response: IngredientRecipeDeleteModalMutationResponse,
|};
*/


/*
mutation IngredientRecipeDeleteModalMutation(
  $id: ID!
) {
  recipeIngredientDelete(input: {id: $id}) {
    deleted
  }
}
*/

const node/*: ConcreteRequest*/ = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "id",
    "type": "ID!"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "fields": [
          {
            "kind": "Variable",
            "name": "id",
            "variableName": "id"
          }
        ],
        "kind": "ObjectValue",
        "name": "input"
      }
    ],
    "concreteType": "RecipeIngredientDeletePayload",
    "kind": "LinkedField",
    "name": "recipeIngredientDelete",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "deleted",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "IngredientRecipeDeleteModalMutation",
    "selections": (v1/*: any*/),
    "type": "Mutation"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "IngredientRecipeDeleteModalMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "id": null,
    "metadata": {},
    "name": "IngredientRecipeDeleteModalMutation",
    "operationKind": "mutation",
    "text": "mutation IngredientRecipeDeleteModalMutation(\n  $id: ID!\n) {\n  recipeIngredientDelete(input: {id: $id}) {\n    deleted\n  }\n}\n"
  }
};
})();
// prettier-ignore
(node/*: any*/).hash = '3325fca0d4a2610f9cae5b80c5390aae';

module.exports = node;
